module.exports = __webpack_public_path__ + "img/1.04.thmb.xs.f371665d.jpg";